import { type HTMLAttributes, type ReactNode } from 'react';
import { Icon } from '../Icon';
import styles from './EmptyState.module.scss';

export interface EmptyStateProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  icon?: boolean;
  'data-testid'?: string;
}

export function EmptyState({
  title,
  description,
  action,
  icon,
  className,
  'data-testid': testId,
  ...rest
}: EmptyStateProps) {
  return (
    <div
      className={[styles['container'], className].filter(Boolean).join(' ')}
      data-icon={icon ? '' : undefined}
      data-testid={testId}
      role="status"
      {...rest}
    >
      {icon && (
        <div className={styles['avatar']}>
          <Icon name="check" size={20} />
        </div>
      )}
      <div className={styles['content']}>
        <p className={styles['title']}>{title}</p>
        {description && <p className={styles['description']}>{description}</p>}
      </div>
      {action && !icon && <div className={styles['action']}>{action}</div>}
    </div>
  );
}
